import { render, staticRenderFns } from "./CardModal.vue?vue&type=template&id=7fee0ebf&scoped=true&"
import script from "./CardModal.vue?vue&type=script&lang=js&"
export * from "./CardModal.vue?vue&type=script&lang=js&"
import style0 from "./CardModal.vue?vue&type=style&index=0&id=7fee0ebf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../var/www/html/cartaz-pratico/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fee0ebf",
  null
  
)

export default component.exports